import moment from 'moment'
import { getDateAndTimeFormat } from './dateEndTime'

// DATE
//14.1
export const createDateObject = (str, time, formats, options) => {
  const { showDateTime } = options
  const { timeFormat, dateFormat} = formats
  const conversions = [dateFormat, `${dateFormat} ${timeFormat}`]
  const mDate = moment(str, conversions, true)
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return {
    date: str ? mDate.format('YYYY-MM-DD') : '',
    time: !!time && showDateTime ? moment(time, [timeFormat, 'HH:mm'], true ).format('HH:mm:ss') : '',
    timeZone
  }
}

// 14
export const createDateObjectV14 = (str, time, formats, options) => {
  const res = createDateObject(str, time, formats, options)
  return `${res.date} ${res.time}`.trim()
}


// TIME
//14.1
export const createTimeObject = (str, date, formats, options) => {
  const { showDate } = options
  const { timeFormat, dateFormat } = formats
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return  {
    date: showDate && date ? (moment(date, dateFormat).format('YYYY-MM-DD') || '') : '',
    time: str ? moment(str, [timeFormat, 'HH:mm'], true).format('HH:mm:ss') : '',
    timeZone
  }
}

// 14
export const createTimeObjectV14 = (str, date, formats, options) => {
  const res = createTimeObject(str, date, formats, options)
  return `${res.date} ${res.time}`.trim()
}

export const convertDatesForState = (value, modes) => {
  const { showTime, showDate } = modes
  const { dateFormat, timeFormat } = getDateAndTimeFormat()

  const mDate = moment(value, ['HH:mm:ss', 'YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ'], true)
  const mOnlyDate = moment(value, 'YYYY-MM-DD', true)
  const mOnlyTime = moment(value, 'HH:mm:ss', true)

  if (mDate.isValid()) {
    return {
      dateForState: mOnlyTime.isValid() ? '' : mDate.toDate(),
      date: showDate && !mOnlyTime.isValid() ? mDate.format(dateFormat.toUpperCase()) : '',
      time: showTime && !mOnlyDate.isValid() ? mDate.format(timeFormat) : ''
    }
  }
  return { dateForState: '', date: '', time: '' }
}

export const convertTimeByTimeZone = (value, prevState, state) => {
  const isTime = moment(value, ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ', 'HH:mm:ss'], true).isValid()
  const isDate = moment(value, ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ', 'YYYY-MM-DD', 'YYYY-M-DD'], true).isValid()

  if(isTime && isDate) {
    if(state.date && state.time) {
      return moment(value).format('YYYY-MM-DDTHH:mm:ssZ')
    }
    if (state.date) {
      return state.date
    }
    if (state.time) {
      return state.time
    }
  }
  return value
}
